import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import { useTransition, animated, config } from 'react-spring'
import { BackStep } from '../../../../components'
import styles from './SecondaryNav.module.scss'

interface SecondaryNavItem {
  text: string
  route: string
}

interface SecondaryNavProps {
  redirect: (route: string) => void
  heading: string
  location: { pathname: string }
  navItems: SecondaryNavItem[]
}

const SecondaryNav = ({ redirect, heading, location, navItems }: SecondaryNavProps) => {
  const [show, setShow] = useState(false)
  useEffect(() => {
    setShow(true)
  }, [])

  const items = navItems.map(navItem => ({
    text: navItem.text,
    active: navItem.route.includes(location.pathname),
    onClick: () => redirect(navItem.route),
  }))

  const transitions = useTransition(show, null, {
    config: config.stiff,
    from: { transform: 'translateX(-230px)' },
    enter: { transform: 'translateX(0)' },
    leave: { transform: 'translateX(-230px)' },
  })

  return (
    <div className={styles.root}>
      {transitions.map(
        ({ item, key, props }) =>
          item && (
            <animated.div key={key} style={props}>
              <BackStep onClick={() => redirect('/dashboard')} />
              <h2 className={styles.heading}>{heading}</h2>
              <nav>
                <ul>
                  {items.map((navItem, i) => {
                    const classes = cx(styles.item, {
                      [styles.active]: navItem.active,
                    })

                    return (
                      <li key={i}>
                        <button className={classes} onClick={navItem.onClick}>
                          {navItem.text}
                        </button>
                      </li>
                    )
                  })}
                </ul>
              </nav>
            </animated.div>
          ),
      )}
    </div>
  )
}

export default SecondaryNav
